var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"items":_vm.items,"filled":"","label":"Selecione o paciente"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }